import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Urls } from 'src/app/Helpers/Urls';
import { Variables } from 'src/app/Helpers/variables';
import { PermissionAdd, UserPermission } from 'src/app/Models/user-permission';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionService {

  url = new Urls();
  apiUrl: string;
  orgId: number;

  constructor(
    private httpclient: HttpClient
  ) {
    this.apiUrl = this.url.apiUrl;
    const v = new Variables();
    const val = localStorage.getItem('oi');
    const oi = CryptoJS.AES.decrypt(val, v.pass).toString(CryptoJS.enc.Utf8);
    this.orgId = +oi;
  }

  getUserPermissions(uid, gid, perm) {
    const v = new Variables();
    const val = localStorage.getItem('oi');
    const oi = CryptoJS.AES.decrypt(val, v.pass).toString(CryptoJS.enc.Utf8);
    this.orgId = +oi;
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/userpermission/' + this.orgId + '/' + uid + '/' + gid + '/' + perm + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  createUserPermission(perm: PermissionAdd) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/userpermission/0';
    return this.httpclient.put<any>(url, perm)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  deleteUserPermission(perm: UserPermission) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const url = this.apiUrl + '/api/userpermission/deleteuserpermission';
    return this.httpclient.put<any>(url + '/' + 0, perm)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  private handleError(error: any) {
    // console.error('error', error);
    throw error;
    return error;
  }

}
